var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuecher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 167 167",
    style: {
      enableBackground: "new 0 0 167 167"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PageItem83899",
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.5,167c46.1,0,83.5-37.4,83.5-83.5S129.6,0,83.5,0S0,37.4,0,83.5S37.4,167,83.5,167z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "PageItem83923",
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.7,80.7c1.4-0.8,2.6-2.6,2.6-4.5c0-3.5-2.6-5.8-7.3-5.8H14.5v22.8c1.8,0.6,4.8,1,8.8,1 c7.5,0,11.9-2.7,11.9-7.7C35.2,83.2,33,81.3,30.7,80.7z M26.7,77.5c0,1-0.6,1.8-2.1,1.8h-3.4v-3.7h3.4 C26.1,75.6,26.7,76.5,26.7,77.5z M24.3,88.8c-1.2,0-2.4-0.1-3.1-0.2v-4.3h4.5c1.7,0,2.4,0.8,2.4,2C28.2,87.8,26.9,88.8,24.3,88.8z  M45.6,68.4c1.6,0,2.8-0.9,2.8-2.5c0-1.6-1.2-2.6-2.8-2.6c-1.5,0-2.7,0.9-2.7,2.6C42.9,67.5,44.1,68.4,45.6,68.4z M53.4,68.4 c1.6,0,2.8-0.9,2.8-2.5c0-1.6-1.2-2.6-2.8-2.6c-1.5,0-2.7,0.9-2.7,2.6C50.6,67.5,51.8,68.4,53.4,68.4z M49.5,94.1 c6.7,0,11.1-4.1,11.1-10.6V70.4h-7.1v13.1c0,2.5-1.4,4.2-4,4.2c-2.5,0-4-1.7-4-4.2V70.4h-7.1v13.2C38.5,90,42.9,94.1,49.5,94.1z  M80.6,87c-0.9,0.5-2.1,0.7-3.4,0.7c-3.4,0-5.9-2.3-5.9-5.6s2.5-5.6,5.9-5.6c1.3,0,2.5,0.2,3.4,0.7l0.1-6.4c-1-0.5-2.9-0.7-4.1-0.7 c-7.2,0-12.4,5.2-12.4,12.1c0,6.9,5.1,12.1,12.3,12.1c1.2,0,3.2-0.2,4.1-0.7L80.6,87z M100.1,70.4v8.2h-8v-8.2h-7.1v23.2h7.1v-8.7 h8v8.7h7.1V70.4H100.1z M118.7,87.7v-3.3h8.9v-5.3h-8.9v-2.8h9.5v-5.9h-16.1v23.2h16.2v-5.9H118.7z M153.5,93.6l-3.8-8.1 c2.1-1.5,3.3-3.8,3.3-6.9c0-5.2-3.7-8.3-9.7-8.3h-10.5v23.2h7.2v-6.2c0.7,0.1,1.5,0.2,2.4,0.2c0.3,0,0.6,0,0.8,0l2.7,6.1H153.5z  M142.1,82.2c-0.7,0-1.4-0.1-2-0.2v-5.5h2.6c2.2,0,3.3,1,3.3,2.7C145.9,81.2,144.6,82.2,142.1,82.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuecher);
export default __webpack_public_path__ + "static/media/Buecher.da56229bb7f140b3613edaa48c74bbea.svg";
export { ForwardRef as ReactComponent };